import styled from '@emotion/styled';
import { media } from '@portalterreno/react-ui-core/Grid';
import Link from 'next/link';

const StyledLink = styled(Link)({
  textDecoration: 'none',
  [media('xs')]: {
    marginRight: '19px',
    minWidth: '235px'
  },
  [media('lg')]: {
    marginRight: '0px',
    minWidth: '0'
  }
});

export default StyledLink;
